import { useMutation } from "@tanstack/react-query";
import { useServices } from "index";

type Callbacks = {
  onSuccess?: (response) => Promise<void> | void;
  onError?: (error: unknown) => void;
};

export const useLookupInstructorEmails = (emailsToCheck: string[], callbacks?: Callbacks) => {
  const organizationsEditorService = useServices().organizationsEditorService;

  return useMutation({
    mutationFn: () => organizationsEditorService.instructorsEmailLookup(emailsToCheck),
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
};